// lib/emails/beantwortet.ts
// #553: Eingangsmail schon beantwortet? Gesendete Antworten tragen die conversation_id der
// Ursprungsmail (graph-mail-send). Ordner wie „Offen“ zeigen nur Eingangsmails — ohne dieses
// Etikett sah man dort nicht, dass schon jemand geantwortet hatte (Gefahr doppelter Antworten).

export interface GesendeteAntwort { conversation_id: string | null; datum: string | null; user_id: string | null }
export interface LetzteAntwort { datum: string; user_id: string | null }

/** Je Verlauf die jüngste gesendete Mail. */
export function letzteAntwortJeVerlauf(gesendet: readonly GesendeteAntwort[]): Map<string, LetzteAntwort> {
  const m = new Map<string, LetzteAntwort>();
  for (const g of gesendet) {
    if (!g.conversation_id || !g.datum) continue;
    const bisher = m.get(g.conversation_id);
    if (!bisher || g.datum > bisher.datum) m.set(g.conversation_id, { datum: g.datum, user_id: g.user_id });
  }
  return m;
}

/** Antwort zu dieser Eingangsmail — nur wenn sie NACH der Mail gesendet wurde. */
export function antwortZu(mail: { conversation_id?: string | null; datum?: string | null; richtung?: string }, antworten: Map<string, LetzteAntwort>): LetzteAntwort | null {
  if (mail.richtung !== 'eingang' || !mail.conversation_id || !mail.datum) return null;
  const a = antworten.get(mail.conversation_id);
  return a && a.datum > mail.datum ? a : null;
}

/** „14:32“ heute, sonst „21.10.“ */
export function antwortZeit(iso: string, jetzt: Date): string {
  const d = new Date(iso);
  const heute = d.toDateString() === jetzt.toDateString();
  return heute
    ? d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })
    : `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.`;
}
